import { render, staticRenderFns } from "./separation.vue?vue&type=template&id=740b0be2"
import script from "./separation.vue?vue&type=script&lang=js"
export * from "./separation.vue?vue&type=script&lang=js"
import style0 from "./separation.vue?vue&type=style&index=0&id=740b0be2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports